import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';

ClassNameGenerator.configure((componentName: string) => componentName.replace('Mui', 'V5')); // load as early as possible this code in a js file
import '../../utils/MuiClassNameSetup';
import { tolgeeModule } from '@rakutenfrance/tolgee-provider';

import React from 'react';

import headerModule from '@rakutenfrance/header';
import { configService as configurationService, publicRuntimeConfig } from '@rakutenfrance/config-service';

import { getServerSidePropsLoader, regroupModuleReducers, GetServerSidePropsReturn } from '@rakutenfrance/redux-apollo-helper';
import { renderReact } from '../../fragmentHelper/renderReactCustom';

import { ReduxApolloFragmentWrapperChildren } from '../../fragmentHelper/Wrapper';

import { createQuery } from './PageQuery';
import { GetServerSidePropsHypernovaWatchContext, PagePropsType } from '../../types';

import '@rakutenfrance/header/build/esm/style.global.css';

export { headerModule };

const config = configurationService.get();

const { HeaderContainer } = headerModule.containers;

const graphQlQuery = createQuery(
  {
    headerModule,
  },
  {
    // includePersonalQuery: config.featureFlipping.ssrPersonalize,
    // includePersonalQuery: typeof window !== 'undefined',
    includePersonalQuery: config.featureFlipping.ssrPersonalize || typeof window !== 'undefined',
    // includePersonalQuery: true,
  }
);

const modules = [headerModule, tolgeeModule];
const reducers = regroupModuleReducers(modules);

const WrappedHeader: React.FC<PagePropsType> = ({ initialApolloState, initialReduxState, moduleName }) => {
  const graphQlvariables = {};

  return (
    <>
      <script
        /* add the server side config loaded from env vars to be usable in the browser, this config is used by  */
        dangerouslySetInnerHTML={{
          __html: `
        window.PUBLIC_RUNTIME_CONFIG = ${JSON.stringify(publicRuntimeConfig)};
      `,
        }}
      />
      <ReduxApolloFragmentWrapperChildren
        initialApolloState={initialApolloState}
        initialReduxState={initialReduxState}
        moduleName={moduleName}
        reducers={reducers}
      >
        <HeaderContainer PERSONALIZED_QUERY_OPTION={graphQlvariables} PERSONALIZED_QUERY={graphQlQuery} />
      </ReduxApolloFragmentWrapperChildren>
    </>
  );
};

export const renderFunction = renderReact('Header', WrappedHeader);

export const serverCanCache = !config.featureFlipping.ssrPersonalize;

export const getServerSideProps = async (watchContext: GetServerSidePropsHypernovaWatchContext): Promise<GetServerSidePropsReturn> => {
  const baseUrl = '';
  const preloadedConfig = {
    header: {
      isHypernova: true,
    },
  };
  const graphQlVariables = {};

  const { initialReduxState, initialApolloState } = await getServerSidePropsLoader(
    watchContext,
    modules,
    baseUrl,
    preloadedConfig,
    graphQlQuery,
    graphQlVariables
  );
  return {
    props: {
      initialReduxState,
      initialApolloState,
    },
  };
};
